import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'
import {objectEntries} from '@jetbrains/teamcity-ui/dist/utils'

export default function invertDictionary<K extends PropertyKey, V extends PropertyKey>(
  src: KeyValue<K, V>,
): KeyValue<V, K> {
  return objectEntries(src).reduce(
    (dest, [key, value]: [K, V | undefined]) => (value != null ? {...dest, [value]: key} : dest),
    Object.freeze({}),
  )
}
